<template>
  <v-flex xs12 sm6 md3 :class="paddingClass">
    <v-autocomplete
      v-model.trim="clientId"
      :search-input.sync="search"
      cache-items
      :loading="isLoading"
      :items="clients"
      item-text="value"
      item-value="id"
      placeholder="Wpisz nazwe klienta"
      hide-no-data
      clearable
      flat
      label="Klient"
    ></v-autocomplete>
  </v-flex>
</template>

<script>
import { getClientFilterList } from '../../../repository/clients/index';

export default {
  name: 'filter-by-client',
  data: () => ({
    clientId: null,
    clients: [],
    search: null,
    isLoading: false,
    descriptionLimit: 60,
  }),
  computed: {
    paddingClass() {
      return this.$vuetify.breakpoint.xs ? 'pr-0' : 'pr-3';
    },
  },
  methods: {
    async getFilterList(searchValue) {
      this.isLoading = true;
      try {
        const clientsFilterList = await getClientFilterList({ name: searchValue });
        this.isLoading = false;
        this.clients = clientsFilterList.data.data.items;
      } catch (e) {
        this.isLoading = false;
      }
    },
  },
  mounted() {
    this.getFilterList();
  },
  watch: {
    search(val) {
      const isInList = this.clients.find(item => item.value === val);
      if (val && !isInList) {
        this.getFilterList(val);
      }
    },
    clientId(id) {
      const { query } = this.$route;
      const newQuery = {
        ...query,
      };
      if (id) {
        newQuery.client_id = id;
      } else {
        delete newQuery.client_id;
      }
      this.$router.push({ path: '/uzytkownicy/1', query: newQuery });
    },
  },
};
</script>
